import { cn } from '@/utils/cn'
import { formatTime } from '@/utils/formatDate'
import type { MessageRole } from '@/types'

interface MessageBubbleProps {
  role: MessageRole
  content: string
  timestamp: string
}

export function MessageBubble({ role, content, timestamp }: MessageBubbleProps) {
  const isUser = role === 'user'

  return (
    <div className={cn('flex', isUser ? 'justify-end' : 'justify-start')}>
      <div
        className={cn(
          'max-w-[70%] rounded-lg px-4 py-2',
          isUser ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-900'
        )}
      >
        <div className="mb-1 flex items-center gap-2">
          <span className="text-xs opacity-70">
            {isUser ? '👤' : '🐻'} {formatTime(timestamp)}
          </span>
        </div>
        <p className="whitespace-pre-wrap">{content}</p>
      </div>
    </div>
  )
}
